import { useEffect } from 'react';
export const isPrerenderAgent = () => {
  return window.navigator.userAgent.includes('Prerender') || window.navigator.userAgent.includes('prerender');
};
export function PrerenderReady({
  ready = true
}) {
  const prerenderReady = ready && isPrerenderAgent();
  useEffect(() => {
    if (prerenderReady) {
      window.prerenderReady = true;
      return () => {
        window.prerenderReady = false;
      };
    }
    return () => {};
  }, [prerenderReady]);
  return null;
}